import React from "react";
import { TrendingUp, TrendingDown, BoxIcon } from "lucide-react";
import { Card, CardContent } from "../ui/Card";
import { cn } from "../../utils/cn";
interface KpiCardProps {
  title: string;
  value: string;
  hint?: string;
  delta?: number;
  icon: BoxIcon;
  tone?: 'blue' | 'green' | 'amber' | 'slate';
}
const tones: Record<string, string> = {
  blue: 'bg-primary/10 text-primary',
  green: 'bg-emerald-500/10 text-emerald-600',
  amber: 'bg-amber-500/10 text-amber-600',
  slate: 'bg-muted text-muted-foreground'
};
export function KpiCard({
  title,
  value,
  hint,
  delta,
  icon: Icon,
  tone = 'blue'
}: KpiCardProps) {
  const positive = (delta ?? 0) >= 0;
  const Trend = positive ? TrendingUp : TrendingDown;
  return <Card className="transition-shadow duration-150 hover:shadow-md" data-id="element-16" data-mp="ouaaqeff7lei">
      <CardContent className="flex items-start gap-4 p-5" data-id="element-17" data-mp="13q82zlm845lg">
        <span className={cn('flex h-11 w-11 shrink-0 items-center justify-center rounded-xl', tones[tone])} data-id="element-18" data-mp="13on5bn4m46jd">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-19" data-mp="3q69imdmqje3m" />
        </span>
        <div className="min-w-0" data-id="element-20" data-mp="3q845vylhbiav">
          <p className="text-sm text-muted-foreground" data-id="element-21" data-mp="3v52trzejut0m">{title}</p>
          <p className="mt-1 text-2xl font-semibold tracking-tight text-foreground" data-id="element-22" data-mp="3v7go261eo174">{value}</p>
          <div className="mt-1 flex items-center gap-1.5 text-xs" data-id="element-23" data-mp="308r244q7lvw">
            {delta !== undefined && <span className={cn('inline-flex items-center gap-0.5 font-medium', positive ? 'text-emerald-600' : 'text-red-600')} data-id="element-24" data-mp="81y41pbie9mm">
                <Trend className="h-3.5 w-3.5" aria-hidden="true" data-id="element-25" data-mp="hyudpyd591sr" />
                {positive ? '+' : ''}
                {delta}%
              </span>}
            {hint && <span className="truncate text-muted-foreground" data-id="element-26" data-mp="mq2nividyp6g">{hint}</span>}
          </div>
        </div>
      </CardContent>
    </Card>;
}